import * as S from './Radio.styled'

const Radio = props => {
  return (
    <S.Radio>
      <input type='radio' {...props} />
      <S.RadioLabel>{props.label}</S.RadioLabel>
    </S.Radio>
  )
}

export default Radio
